import { LngLat } from "mapbox-gl";

import { GridFilterModel, GridSortModel } from "@mui/x-data-grid";
import { filterModelToQueryValue } from "../util/tableUtils";

export const getImageForHazard = (emergencyHazard: EmergencyHazardType): string => {
  if (emergencyHazard === "Flood") {
    return `${process.env.PUBLIC_URL}images/icons/RiskExposure/cys-flood-warning.png`;
  } else if (emergencyHazard === "Mass movement")
    return `${process.env.PUBLIC_URL}images/icons/RiskExposure/cys-lansslide-warning.png`;
  else {
    return `${process.env.PUBLIC_URL}images/companies/cystellar.com`;
  }
};

export const goToEventPage = (eventId: string) => {
  const wnd = window.open(`#/emergencyMonitoring/${eventId}`, "_blank");
  if (!wnd) return;

  wnd.onload = function () {
    wnd.document.title = `${eventId}`;
  };
};

export const calcLngLatByEventCentroid = (extent: string): { lngLat: LngLat; zoom: number } => {
  // "extent": "POLYGON ((11.329812 43.991522, 11.361602 43.977659, 11.322004 43.943985, 11.306972 43.946657, 11.298316 43.966023, 11.329812 43.991522))",

  const polygon = extent.slice(extent.indexOf("((") + 2, extent.indexOf("))"));
  const points = polygon.split(", ");
  let minLng = 180;
  let maxLng = -180;
  let minLat = 90;
  let maxLat = -90;
  points.forEach((point) => {
    const [lng, lat] = point.split(" ");
    minLng = Math.min(minLng, parseFloat(lng));
    maxLng = Math.max(maxLng, parseFloat(lng));
    minLat = Math.min(minLat, parseFloat(lat));
    maxLat = Math.max(maxLat, parseFloat(lat));
  });
  const centerLng = (minLng + maxLng) / 2;
  const centerLat = (minLat + maxLat) / 2;
  const diagonalLog = Math.log2(Math.sqrt((maxLng - minLng) ** 2 + (maxLat - minLat) ** 2));
  const zoomConstantForBoxWithDiagonalTwoDegrees = 9;
  const zoom = zoomConstantForBoxWithDiagonalTwoDegrees - diagonalLog;
  return { lngLat: new LngLat(centerLng, centerLat), zoom };
};

export const getFilterQuery = (filterModel: GridFilterModel, activationCode: string) => {
  const filterModelWithActivationCode = {
    ...filterModel,
    items: [...filterModel.items, { field: "activationCode", operator: "equals", value: activationCode }],
  };

  const filterQuery = filterModelToQueryValue(filterModelWithActivationCode);
  return filterQuery;
};

export const getSortDetailsString = (sortModel: GridSortModel) => {
  let sortField, sortDirection;
  const sortItem = sortModel;
  if (sortItem && Object.keys(sortItem).length) {
    const { field, sort } = sortItem[0];
    sortField = field;
    sortDirection = sort;
  }
  return `orderBy=${sortField}&orderDirection=${sortDirection}`;
};
